/* eslint-disable @typescript-eslint/indent */
import { validateOnCompletedAndOnErrorOptions } from '@netfront/common-library';

import { ADD_USERS_TO_UNIT_MUTATION } from './useAddUsersToUnit.graphql';
import {
  IAddUsersToUnitMutationGraphQLResponse,
  IAddUsersToUnitMutationVariables,
  IHandleAddUsersToUnitParams,
  IUseAddUsersToUnitOptions,
  IUseAddUsersToUnit,
} from './useAddUsersToUnit.interfaces';
import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

const useAddUsersToUnit = (options?: IUseAddUsersToUnitOptions): IUseAddUsersToUnit => {
  const { mutation, onCompleted, onCompletedAsync, onError, onErrorAsync, product, tokens } = options ?? {};

  validateOnCompletedAndOnErrorOptions({
    onCompleted,
    onCompletedAsync,
    onError,
    onErrorAsync,
  });

  const [executeAddUsersToUnits, { loading: isLoading }] = useLoggedGeladaMutation<
  IAddUsersToUnitMutationGraphQLResponse,
  IAddUsersToUnitMutationVariables
  >({
    mutation: mutation ?? ADD_USERS_TO_UNIT_MUTATION,
    options: {
      onCompleted: ({ unit: { addUserToUnit } }) => {
        if (onCompleted) {
          onCompleted({
            addUserToUnit,
          });
        }
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        }

        if (onErrorAsync) {
          void onErrorAsync(error);
        }
      },
    },
    product,
    tokens,
  });

  const handleAddUsersToUnit = async ({
    unitId,
    userIds
  }: IHandleAddUsersToUnitParams) => {
    await executeAddUsersToUnits({
      variables: {
        unitId,
        userIds
      },
    });
  };

  return {
    handleAddUsersToUnit,
    isLoading,
  };
};

export { useAddUsersToUnit };
